export class DocumentsNotes {
  public static documents = [];
}
